import React, { useEffect, useState } from "react";
import { IoPersonSharp } from "react-icons/io5";
import { MdCall } from "react-icons/md";
import { BiVideoPlus } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { FaCalendarAlt, FaSyncAlt, FaPlus } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { Button, Checkbox, message, Modal, Tooltip, Spin } from "antd";
import { useDispatch } from "react-redux";
import { RWebShare } from "react-web-share";
import moment from "moment";

import Edit from "../../../../Assets/Icons/edit1.svg";
import View from "../../../../Assets/Icons/visibility.svg";
import Share from "../../../../Assets/Icons/share1.svg";
import EditWhite from "../../../../Assets/Images/Svg/EditWhite.svg";
import ViewWhite from "../../../../Assets/Images/Svg/ViewWhite.svg";
import ShareWhite from "../../../../Assets/Images/Svg/ShareWhite.svg";
import MedWhite from "../../../../Assets/Images/Svg/MedWhite.svg";
import LabWhite from "../../../../Assets/Images/Svg/LabWhite.svg";
import close from "../../../../Assets/Icons/close1.svg";
import Preview from "../../../../Assets/Images/Svg/PreviewIcon.svg";

import AppointmentService from "../../../../Services/AppointmentService";
import ConsultationService from "../../../../Services/ConsultationService";
import PatientService from "../../../../Services/PatientService";
import CommonFunctions from "../../../Shared/CommonFunctions";
import { APP_ROUTES } from "../../../../PageRouting/approutes";
import { getLoaderState } from "../../../../Redux/actions/CommonActions";
import { setSelectedAppt } from "../../../../Redux/actions/UserActions";
import { notifyPatient } from "../../../../config/firebase";

import ShareOrders from "../../NewDashboard/ShareOrders";
import SharePrescription from "../../NewDashboard/SharePrescription";
import RescheduleAppt from "../../NewDashboard/RescheduleAppt";
import PayAgain from "../../NewDashboard/PayAgain";
import PrescriptionDetails from "../../ConsultationNotes/VitalTabs/ViewPrescription/PrescriptionDetails";
import NoAppointmentsCard from "../../Appointments/NoAppointmentsCard";
import ViewLabReports from "../../Appointments/ViewLabReports";
import MedOrderPreview from "../../Appointments/MedOrderPreview";
import LabOrderPreview from "../../Appointments/LabOrderPreview";
import Summary from "../../VideoConsultation/Summary";
import IPDPatientInvite from "./IPDPatientInvite";

function IPDConsultation({
  patientDetails,
  patientId,
  admissionId,
  admission,
}) {
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [cancelAppointmentID, setCancelAppointmentID] = useState({});
  const [cancelReason, setCancelReason] = useState("");
  const [refundable, setRefundable] = useState(false);

  const [preview, setPreview] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);

  const [previewType, setPreviewType] = useState("M");
  const [showLabReport, setShowLabReport] = useState(false);
  const [labReportData, setLabReportData] = useState({});
  const [pharmaMed, setPharmaMed] = useState(false);
  const [medRecord, setMedRecord] = useState({});

  const history = useHistory();
  const dispatch = useDispatch();

  const storedLoginResult =
    sessionStorage.getItem("login_result") ||
    localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const effectivePatientId =
    patientId ||
    patientDetails?.patientId ||
    admission?.patientId;

  const getAppointments = async () => {
    if (!effectivePatientId) return;
    setLoading(true);
    try {
      const payload = {
        patientId: effectivePatientId,
      };
      const res = await AppointmentService.AppointmentFilter(payload);
      setAppointmentsList(res?.data || []);
    } catch (error) {
      console.error("Error fetching patient appointments:", error);
      message.error("Failed to fetch appointments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAppointments();
  }, [effectivePatientId]);

  useEffect(() => {
    if (cancelAppointmentID && cancelAppointmentID.status === 1) {
      setRefundable(true);
    }
  }, [cancelAppointmentID]);

  const handlePharmaMedOpen = (record, type) => {
    setPreviewType(type);
    setMedRecord(record);
    setPharmaMed(true);
  };

  const handlePharmaMedClose = () => {
    setPharmaMed(false);
  };

  const handlePreviewOk = () => {
    setPreview(false);
  };

  const handlePreviewCancel = () => {
    setPreview(false);
  };

  const showModal = (record) => {
    setIsModalOpen(true);
    setCancelAppointmentID(record);
  };

  const cancelAppointment = () => {
    setIsModalOpen(false);
    setRefundable(false);
    setCancelReason("");
    setCancelAppointmentID({});
  };

  const handleOk = () => {
    if (cancelReason === "") {
      message.error("Enter reason");
      return;
    }
    const payload = {
      appointmentId: cancelAppointmentID.appointmentId,
      cancelReason: cancelReason,
      cancelledById:
        cancelAppointmentID.userId || loginResultObject?.user?.userId,
      cancelledByType: "USER",
      refundYN: refundable ? "Y" : "N",
      paymentType: cancelAppointmentID.paymentType,
    };
    AppointmentService.AppointmentCancelNew(payload)
      .then(() => {
        setIsModalOpen(false);
        getAppointments();
        message.success("Appointment Cancelled");
        setCancelReason("");
        setRefundable(false);
        setCancelAppointmentID({});
      })
      .catch(() => {
        message.error("Please try again");
      });
  };

  const handleClick = async (record, tab) => {
    dispatch(getLoaderState(true));

    if (tab === "1") {
      const startPayload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId || loginResultObject?.user?.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId || loginResultObject?.user?.userId,
        userName: record?.userName,
        personType: "Doctor",
      };

      ConsultationService.updateStartTime(startPayload).catch(() => {});
    }

    try {
      const patientPayload = {
        patientId: record.patientId,
      };

      PatientService.PatientListFilter(patientPayload).then((res) => {
        if (res?.data?.[0]) {
          sessionStorage.setItem("patient", JSON.stringify(res.data[0]));
        }
      });

      const apptPayload = {
        appointmentId: record.appointmentId,
      };

      const result = await AppointmentService.AppointmentFilter(apptPayload);
      await notifyPatient(
        record.patientId,
        record.appointmentId,
        record.userName,
        record.userId
      );
      dispatch(setSelectedAppt(record));
      sessionStorage.setItem("selectedAppt", JSON.stringify(record));
      history.push(APP_ROUTES.VIDEOCALL, {
        selectedPatient: result?.data?.[0] || record,
      });
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
      message.error("An error occurred, please try again");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  const showPreview = async (record) => {
    dispatch(getLoaderState(true));
    const patientPayload = {
      patientId: record?.patientId,
    };
    const consultationPayload = {
      consultationId: record?.consultationId,
      detailsYN: "Y",
    };
    try {
      const patientResponse = await PatientService.PatientListFilter(
        patientPayload
      );
      if (patientResponse?.data) {
        setSelectedPatient(patientResponse.data[0]);
      }
      const consultationResponse = await ConsultationService.getPrescriptions(
        consultationPayload
      );
      if (consultationResponse?.data) {
        setSelectedPrescription(consultationResponse.data[0]);
        setPreview(true);
      }
    } catch (e) {
      console.error(e);
      message.error("Failed to load prescription preview");
    } finally {
      dispatch(getLoaderState(false));
    }
  };

  const handleRefundable = () => {
    setRefundable(!refundable);
  };

  const getInitials = (name) => {
    if (!name) return "";
    const cleanName = name.replace(/^Mr\.?\s*/i, "").trim();
    return cleanName.slice(0, 1).toUpperCase();
  };

  return (
    <div className="flex flex-col gap-5 py-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h2 className="text-[18px] font-bold text-[#111827]">
            IPD Consultation
          </h2>
          <span className="text-[13px] font-medium text-[#6b7280]">
            ({appointmentsList.length} Appointments)
          </span>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={getAppointments}
            className="flex items-center gap-2 border border-[#e5e7eb] rounded-lg px-4 h-10 bg-white text-[#374151] cursor-pointer hover:bg-gray-50 text-[13px] font-semibold transition-colors"
          >
            <FaSyncAlt className={`text-[#6b7280] ${loading ? "animate-spin" : ""}`} />
            <span>Refresh</span>
          </button>

          <button
            onClick={() => setIsInviteModalOpen(true)}
            className="h-10 px-5 rounded-lg bg-[#008f9f] text-white text-[13px] font-semibold flex items-center gap-2 hover:bg-[#007a8a] transition-colors"
          >
            <FaPlus className="text-[12px]" />
            <span>Schedule Consultation</span>
          </button>
        </div>
      </div>

      {/* Content Table */}
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <Spin size="large" />
        </div>
      ) : appointmentsList && appointmentsList.length > 0 ? (
        <div className="overflow-x-auto my-2">
          <table className="min-w-full border border-gray-200 shadow-md rounded-md customTable">
            <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
              <tr>
                <th className="p-3 whitespace-nowrap text-[#F5FEFA] w-12">
                  Photo
                </th>
                <th className="p-3 whitespace-nowrap">Patient</th>
                <th className="p-3 whitespace-nowrap">Appt. ID</th>
                <th className="p-3 whitespace-nowrap">Chief Complaints</th>
                <th className="p-3 whitespace-nowrap">Date & Time</th>
                <th className="p-3 whitespace-nowrap">Call Type</th>
                <th className="p-3 whitespace-nowrap">Rx</th>
                <th className="p-3 whitespace-nowrap">Refill Date</th>
                <th className="p-3 whitespace-nowrap">Payment Status</th>
                <th className="p-3 whitespace-nowrap">Orders</th>
                <th className="p-3 whitespace-nowrap">Med Order ID</th>
                <th className="p-3 whitespace-nowrap">Lab Order ID</th>
                <th className="p-3 whitespace-nowrap">Appointment Status</th>
                <th className="p-3 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="text-sm">
              {appointmentsList.map((record, index) => (
                <tr
                  key={record.appointmentId || index}
                  className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                >
                  {/* Photo */}
                  <td className="p-3">
                    {record.photoName ? (
                      <img
                        src={process.env.REACT_APP_IMAGE_URL + record.photoName}
                        alt={record.patientName || "Patient"}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                    ) : (
                      <div className="h-10 w-10 rounded-full flex items-center justify-center text-white bg-brand-primaryColor font-bold">
                        <span>{getInitials(record.patientName || patientDetails?.firstName)}</span>
                      </div>
                    )}
                  </td>

                  {/* Patient Name & ID */}
                  <td className="p-3 whitespace-nowrap">
                    <div className="font-semibold text-[#111827]">
                      {record.patientName ||
                        (patientDetails
                          ? `${patientDetails?.firstName || ""} ${patientDetails?.lastName || ""}`.trim()
                          : "-")}
                    </div>
                    <div className="text-brand-textDarkgray text-xs mb-0">
                      {record.patientId || effectivePatientId}
                    </div>
                  </td>

                  {/* Appointment ID */}
                  <td className="p-3 whitespace-nowrap font-medium">
                    {record.appointmentId}
                  </td>

                  {/* Chief Complaints */}
                  <td className="p-3 whitespace-nowrap max-w-[200px] truncate" title={record.appointmentReason}>
                    {record.appointmentReason || "-"}
                  </td>

                  {/* Date & Time */}
                  <td className="p-3 whitespace-nowrap">
                    <span className="flex flex-col">
                      <span>
                        {record.appointmentDate
                          ? moment.utc(record.appointmentDate).local().format("DD/MM/YYYY")
                          : "-"}
                      </span>
                      <span className="text-xs text-gray-500">
                        {record.startTime || ""}
                      </span>
                    </span>
                  </td>

                  {/* Call Type / Consult */}
                  <td className="p-3 whitespace-nowrap">
                    {record.status === 2 || record.status === 9 ? (
                      <button
                        className="flex items-center justify-center w-28 gap-2 px-1 py-2 bg-gray-400 rounded text-white cursor-not-allowed text-xs font-semibold"
                        disabled
                      >
                        {record.serviceCode === "APPT_VIDEO" ||
                        record.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {record.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                Audio
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5" /> Consult
                          </>
                        )}
                      </button>
                    ) : !record.transactionId &&
                      record.paymentConsultation === "BC" ? (
                      <Tooltip placement="top" title={"Payment is not completed"}>
                        <button
                          className="bg-gray-400 text-white px-3 py-2 rounded flex items-center justify-center w-28 gap-1 cursor-not-allowed text-xs font-semibold"
                          disabled
                        >
                          {record.serviceCode === "APPT_VIDEO" ||
                          record.serviceCode === "APPT_AUDIO" ? (
                            <>
                              {record.serviceCode === "APPT_VIDEO" ? (
                                <>
                                  <BiVideoPlus className="w-5 h-5" />
                                  Join call
                                </>
                              ) : (
                                <>
                                  <MdCall className="w-5 h-5" />
                                  Audio
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <IoPersonSharp className="w-5 h-5" /> Consult
                            </>
                          )}
                        </button>
                      </Tooltip>
                    ) : (
                      <button
                        onClick={() => handleClick(record, "1")}
                        className="bg-brand-primaryColor text-white w-28 px-3 py-2 rounded flex items-center justify-center gap-1 hover:opacity-90 text-xs font-semibold transition-opacity"
                      >
                        {record.serviceCode === "APPT_VIDEO" ||
                        record.serviceCode === "APPT_AUDIO" ? (
                          <>
                            {record.serviceCode === "APPT_VIDEO" ? (
                              <>
                                <BiVideoPlus className="w-5 h-5" />
                                Join call
                              </>
                            ) : (
                              <>
                                <MdCall className="w-5 h-5" />
                                Audio
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoPersonSharp className="w-5 h-5" /> Consult
                          </>
                        )}
                      </button>
                    )}
                  </td>

                  {/* Rx */}
                  <td className="p-3 whitespace-nowrap">
                    {record.status === 2 ? (
                      <div className="flex gap-2 items-center">
                        <Tooltip placement="top" title="Edit Consultation">
                          <div
                            onClick={() => handleClick(record, "2")}
                            className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer hover:bg-[#c9eeec] transition-colors"
                          >
                            <img src={Edit} alt="Edit" />
                          </div>
                        </Tooltip>
                        <Tooltip placement="top" title="View Prescription">
                          <div
                            onClick={() => showPreview(record)}
                            className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer hover:bg-[#c9eeec] transition-colors"
                          >
                            <img src={View} alt="View" />
                          </div>
                        </Tooltip>
                        <SharePrescription record={record} />
                      </div>
                    ) : (
                      <div className="flex gap-2 items-center">
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={EditWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ViewWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ShareWhite} alt="" />
                        </div>
                      </div>
                    )}
                  </td>

                  {/* Refill Date */}
                  <td className="p-3 whitespace-nowrap">
                    <span className="text-sm">
                      {record?.refillDate || "N/A"}
                    </span>
                  </td>

                  {/* Payment Status */}
                  <td className="p-3 whitespace-nowrap">
                    <div className="flex flex-col gap-1 items-start">
                      <span
                        className={`px-3 py-1 rounded-md text-center text-xs font-semibold ${
                          record.transactionId
                            ? "bg-[#31E4A81A] text-green-600"
                            : "bg-[#FF60601A] text-red-600"
                        }`}
                      >
                        {record.transactionId ? "Completed" : "Pending"}
                      </span>
                      <PayAgain
                        record={record}
                        appointmentsList={getAppointments}
                      />
                    </div>
                  </td>

                  {/* Orders */}
                  <td className="p-3 whitespace-nowrap">
                    {record.status === 2 ? (
                      <div className="flex gap-2">
                        <ShareOrders
                          record={record}
                          getList={getAppointments}
                        />
                      </div>
                    ) : (
                      <div className="flex gap-2">
                        <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={MedWhite} alt="" />
                        </span>
                        <span className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={LabWhite} alt="" />
                        </span>
                      </div>
                    )}
                  </td>

                  {/* Med Order ID */}
                  <td className="p-3 whitespace-nowrap">
                    {record.drugPrescriptionStatus === "Dispensed"  ? (
                      <div className="flex items-center">
                        <span
                          className="border px-2 py-1 rounded-md border-brand-primaryColor text-brand-primaryColor font-semibold cursor-pointer hover:bg-teal-50"
                          onClick={() => handlePharmaMedOpen(record, "M")}
                        >
                          {record.pharmacyOrderId}
                        </span>
                      </div>
                    ) : (
                      <span className="bg-[#31E4A81A] text-green-600 px-3 py-1 rounded-md text-xs font-medium">
                        {record.drugPrescriptionStatus || "N/A"}
                      </span>
                    )}
                  </td>

                  {/* Lab Order ID */}
                  <td className="p-3 whitespace-nowrap">
                    {record.labPrescriptionStatus === "Tested" ? (
                      <div className="flex items-center gap-1">
                        <span
                          className="border px-2 py-1 rounded-md border-brand-primaryColor text-brand-primaryColor font-semibold cursor-pointer hover:bg-teal-50"
                          onClick={() => handlePharmaMedOpen(record, "L")}
                        >
                          {record.labOrderId}
                        </span>
                        <img
                          src={Preview}
                          alt="Preview"
                          className="w-6 h-6 rounded-md cursor-pointer hover:opacity-80"
                          onClick={() => {
                            setShowLabReport(true);
                            setLabReportData(record);
                          }}
                        />
                      </div>
                    ) : (
                      <span className="bg-[#31E4A81A] text-green-600 px-3 py-1 rounded-md text-xs font-medium">
                        {record.labPrescriptionStatus || "N/A"}
                      </span>
                    )}
                  </td>

                  {/* Appointment Status */}
                  <td className="p-3 whitespace-nowrap">
                    {record.status === 9 && (
                      <span className="px-3 py-1 rounded-md text-xs font-semibold bg-[#FF60601A] text-red-600">
                        Cancelled
                      </span>
                    )}
                    {record.status === 0 && (
                      <span className="px-3 py-1 rounded-md text-xs font-semibold bg-[#EBA8171A] text-yellow-600">
                        Pending
                      </span>
                    )}
                    {record.status === 1 && (
                      <span className="px-3 py-1 rounded-md text-xs font-semibold bg-[#EBA8171A] text-yellow-600">
                        Pending
                      </span>
                    )}
                    <div className="flex gap-2 items-center">
                      {record.status === 2 && (
                        <span className="px-3 py-1 rounded-md text-xs font-semibold bg-[#31E4A81A] text-green-600">
                          Completed
                        </span>
                      )}
                      {record.status === 2 &&
                        record.serviceCode === "APPT_INPERSON" && (
                          <Summary record={record} />
                        )}
                    </div>
                  </td>

                  {/* Actions */}
                  <td className="p-3 whitespace-nowrap">
                    {record.status === 1 ? (
                      <div className="flex gap-2 items-center">
                        <Tooltip placement="top" title="Cancel Appointment">
                          <div
                            onClick={() => showModal(record)}
                            className="w-8 h-8 rounded-full bg-red-200 flex items-center justify-center cursor-pointer hover:bg-red-300 transition-colors"
                          >
                            <img src={close} alt="Cancel" />
                          </div>
                        </Tooltip>
                        <Tooltip placement="top" title="Share Link">
                          <div className="w-8 h-8 rounded-full bg-[#DEF3F2] flex items-center justify-center cursor-pointer hover:bg-[#c9eeec] transition-colors">
                            <RWebShare
                              data={{
                                text: "Appointment",
                                url: `${process.env.REACT_APP_WEBSITEURL || ""}vc?ref=${record?.appointmentId}/N`,
                                title: "Share Link",
                              }}
                            >
                              <img src={Share} alt="Share" />
                            </RWebShare>
                          </div>
                        </Tooltip>
                        <RescheduleAppt
                          record={record}
                          getList={getAppointments}
                        />
                      </div>
                    ) : (
                      <div className="flex gap-2 items-center">
                        <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <IoMdClose />
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <img src={ShareWhite} alt="" />
                        </div>
                        <div className="w-8 h-8 rounded-full text-white bg-gray-300 flex items-center justify-center cursor-not-allowed">
                          <FaCalendarAlt className="text-white" />
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <NoAppointmentsCard />
      )}

      {/* Lab Report Modal */}
      {showLabReport && (
        <Modal
          title="Lab Reports"
          open={showLabReport}
          onCancel={() => setShowLabReport(false)}
          style={{ top: 40 }}
          width={800}
          footer={null}
        >
          <ViewLabReports labReportData={labReportData} />
        </Modal>
      )}

      {/* Medication / Lab Preview Modal */}
      {pharmaMed && (
        <Modal
          title=""
          open={pharmaMed}
          onCancel={handlePharmaMedClose}
          style={{ top: 40 }}
          width={1000}
          footer={null}
        >
          {previewType === "M" ? (
            <MedOrderPreview medRecord={medRecord} />
          ) : (
            <LabOrderPreview medRecord={medRecord} />
          )}
        </Modal>
      )}

      {/* Prescription Preview Modal */}
      {preview && (
        <Modal
          open={preview}
          onOk={handlePreviewOk}
          onCancel={handlePreviewCancel}
          style={{ top: 40 }}
          width={"70%"}
          footer={null}
        >
          <PrescriptionDetails
            prescription={selectedPrescription}
            selectedPatient={selectedPatient}
          />
        </Modal>
      )}

      {/* Cancel Appointment Modal */}
      <Modal
        title="Cancel Appointment"
        open={isModalOpen}
        onCancel={cancelAppointment}
        footer={null}
        width={400}
        destroyOnClose
      >
        <div>
          <span className="font-sans font-normal text-sm text-gray-700">
            Are you sure you want to cancel this appointment?
          </span>
          <div className="relative mt-5">
            <textarea
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              rows="4"
              placeholder="Cancel Reason..."
              className="peer w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#189FAA] text-sm font-medium text-[#333] bg-transparent"
            />
            <div className="mt-3 flex items-center gap-2">
              <Checkbox
                checked={refundable}
                disabled={
                  cancelAppointmentID?.status === 0 ||
                  cancelAppointmentID?.status === 9 ||
                  (cancelAppointmentID?.paymentType === "FullDiscount" &&
                    cancelAppointmentID?.status === 1)
                }
                onChange={handleRefundable}
                className="text-[#969CA5]"
              />
              <label className="text-[#A0A2A3] text-sm">
                Refund Applicable
              </label>
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6">
            <Button
              className="h-8 w-20 text-[#189FAA]"
              onClick={cancelAppointment}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              className="h-8 w-40 font-sans font-semibold bg-brand-primaryColor text-white"
              type="primary"
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>

      {/* Schedule IPD Consultation Modal */}
      <Modal
        title="Schedule IPD Consultation"
        open={isInviteModalOpen}
        onCancel={() => setIsInviteModalOpen(false)}
        footer={null}
        width={750}
        destroyOnClose
      >
        <IPDPatientInvite
          inviteDetails={
            patientDetails || {
              patientId: effectivePatientId,
              firstName: "",
              lastName: "",
            }
          }
          handleInviteOk={() => {
            setIsInviteModalOpen(false);
            getAppointments();
          }}
          handleCancel={() => setIsInviteModalOpen(false)}
        />
      </Modal>
    </div>
  );
}

export default IPDConsultation;
